<template>
  <div>
    <div class="page-wrapper">
      <div class="container-fluid p-0">
        <div class="row justify-content-center align-items-center min-vh-100">
          <div class="col-10 col-md-6 col-lg-4">
            <div class="text-center">
              <div>
                <div class="logo d-block mb-4">
                  <img class="img-fluid" src="../../../assets/images/logo/sfa_logo.svg" alt="SFA Logo" style="max-width: 200px;">
                </div>
                <div class="login-main">
                  <form class="theme-form" @submit.prevent="verifyOTP">
                    <h4 class="mb-4">Verification</h4>
                    <p class="mb-4">
                      Enter the verification code received via SMS to your mobile number
                      {{ maskedMobile }}
                    </p>
                    <div class="otp-input-group d-flex justify-content-between">
                      <input
                          class="otp-box"
                          type="text"
                          maxlength="1"
                          @input="filterOtpInput($event, 0)"
                          @keydown.backspace="focusPrevious($event, 0)"
                          ref="otp0"
                      >
                      <input
                          class="otp-box"
                          type="text"
                          maxlength="1"
                          @input="filterOtpInput($event, 1)"
                          @keydown.backspace="focusPrevious($event, 1)"
                          ref="otp1"
                      >
                      <input
                          class="otp-box"
                          type="text"
                          maxlength="1"
                          @input="filterOtpInput($event, 2)"
                          @keydown.backspace="focusPrevious($event, 2)"
                          ref="otp2"
                      >
                      <input
                          class="otp-box"
                          type="text"
                          maxlength="1"
                          @input="filterOtpInput($event, 3)"
                          @keydown.backspace="focusPrevious($event, 3)"
                          ref="otp3"
                      >
                      <input
                          class="otp-box"
                          type="text"
                          maxlength="1"
                          @input="filterOtpInput($event, 4)"
                          @keydown.backspace="focusPrevious($event, 4)"
                          ref="otp4"
                      >
                      <input
                          class="otp-box"
                          type="text"
                          maxlength="1"
                          @input="filterOtpInput($event, 5)"
                          @keydown.backspace="focusPrevious($event, 5)"
                          ref="otp5"
                      >
                    </div>

                    <!-- Resend OTP Button -->
                    <div class="d-flex align-items-center justify-content-between mt-4">
                      <span>Didn't get the OTP?</span>
                      <div class="d-flex align-items-center">
                        <span v-if="requesting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <button
                            type="button"
                            class="btn btn-link p-0"
                            :disabled="requesting"
                            @click="resendOTP"
                        >
                          {{ requesting ? 'Sending OTP' : 'Resend OTP' }}
                        </button>
                      </div>
                    </div>

                    <!-- Verify OTP Button -->
                    <div class="d-grid mt-4">
                      <button class="btn button-default btn-block w-100" :disabled="verifying">
                        <span v-if="verifying" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        <span v-else>Verify OTP</span>
                      </button>
                    </div>
                    <br>

                    <!-- Copyright widget -->
                    <small class="mt-4 mb-0 text-center text-xs">
                      Copyright &copy; 2024. All Rights Reserved. <br> Developed by LAUGFS Group IT
                    </small>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {requestOTP} from '@/services/dataService';
import {verifyOTP} from '@/services/dataService';
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification';

export default {
  data() {
    return {
      maskedMobile: '', // Default placeholder

      user: {
        mobile: {
          value: '',
          errormsg: ''
        },
        requestOTPError: '', // Add this line for request OTP Error message
      },
      verifyOTPError: '', // Add this line for request OTP Error message
      requesting: false, // Add loading state
      verifying: false, // Add verifying state
    };
  },

  mounted() {
    const mobile = localStorage.getItem('mobile') || '';
    if (mobile && mobile.length >= 4) {
      // Mask the mobile number, keeping the first two and last two digits visible
      this.maskedMobile = `${mobile.slice(0, 2)}*****${mobile.slice(-2)}`;
    }
  },

  setup() {
    const router = useRouter();
    const toast = useToast(); // Initialize the toaster
    return { router, toast };
  },

  methods: {
    focusNext(event, index) {
      if (event.target.value && index < 5) {
        this.$refs[`otp${index + 1}`].focus();
      }
    },
    focusPrevious(event, index) {
      if (!event.target.value && index > 0) {
        this.$refs[`otp${index - 1}`].focus();
      }
    },
    filterOtpInput(event, index) {
      const value = event.target.value;
      // Allow only numeric characters
      event.target.value = value.replace(/\D/g, '');
      // Automatically move to the next input if a number is entered
      if (event.target.value && index < 5) {
        this.$refs[`otp${index + 1}`].focus();
      }
    },

    //Resend OTP
    async resendOTP() {
      this.user.requestOTPError = ''; // Clear previous request OTP Error message

      this.requesting = true; // Set loading to true when login starts

      try {
        // Retrieve mobile from localStorage
        const storedMobile = localStorage.getItem('mobile');

        // Request OTP API call
        const userResponse = await requestOTP(storedMobile);

        // Show success toaster with response message
        if (userResponse.data && userResponse.data.message) {
          // Check if `mobile` has a value
          if (userResponse.data.data.mobile) {
            localStorage.setItem('mobile', userResponse.data.data.mobile);
            localStorage.setItem('token_set', userResponse.data.data.token);
          } else {
            localStorage.setItem('token_set', userResponse.data.data.token);
            localStorage.setItem('mobile', this.user.mobile.value);
          }
          this.toast.success(userResponse.data.message);
          this.$router.push({ name: 'VerifyOTP' });
        }

      } catch (error) {
        // Handle invalid credentials
        if (error.response && error.response.data && error.response.data.message) {
          this.user.requestOTPError = error.response.data.message;
          this.toast.error(this.user.requestOTPError); // Show toaster for login error
        } else {
          this.user.requestOTPError = "An error occurred. Please try again.";
          this.toast.error(this.user.requestOTPError); // Show toaster for general error
        }
        console.error('API Error:', error);
      } finally {
        this.requesting = false; // Set loading to false when login completes
      }
    },

    //Verify OTP
    async verifyOTP() {
      const otp = Array.from({ length: 6 }, (_, i) => this.$refs[`otp${i}`].value).join('');

      console.log(`Entered OTP: ${otp}`); // Replace this with actual OTP submission logic

      if (otp.length === 6) {
        this.user.verifyOTPError = '';

        this.verifying = true; // Set loading to true when verify otp

        try {
          //  Retrieve token from localStorage
          const token = localStorage.getItem('token_set');

          // Retrieve mobile from localStorage
          const storedMobile = localStorage.getItem('mobile');

          // Verify OTP API call
          const userResponse = await verifyOTP(token, storedMobile, otp);

          // Show success toaster with response message
          if (userResponse.data && userResponse.data.message) {
            // Check if `mobile` has a value
            if (userResponse.data.data.mobile) {
              localStorage.setItem('mobile', userResponse.data.data.mobile);
              localStorage.setItem('otp', userResponse.data.data.otp);
            } else {
              localStorage.setItem('mobile', this.user.mobile.value);
              localStorage.setItem('otp', this.otp);
            }
            this.toast.success(userResponse.data.message);
            this.$router.push('/reset-password');
          }
        } catch (error) {
          // Handle invalid credentials
          if (error.response && error.response.data && error.response.data.message) {
            this.user.verifyOTPError = error.response.data.message;
            this.toast.error(this.user.verifyOTPError); // Show toaster for login error
          } else {
            this.user.verifyOTPError = "An error occurred. Please try again.";
            this.toast.error(this.user.verifyOTPError); // Show toaster for general error
          }
          console.error('API Error:', error);
        } finally {
          this.verifying = false; // Set loading to false when verifying otp completes
        }
      } else {
        this.toast.error('Please enter a valid 6-digit OTP.'); // Show toaster for login error
      }
    },
  }
};
</script>

<style scoped>
.page-wrapper {
  background-color: #f8f9fa;
}

.login-main {
  background-color: #fff;
  padding: 30px 40px; /* 30px top/bottom padding, 40px left/right padding */
  border-radius: 20px; /* Adjust the border radius as needed */
}

.otp-input-group .otp-box {
  width: 45px;
  height: 45px;
  text-align: center;
  font-size: 1.0rem;
  color: #000;
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.otp-input-group {
  gap: 10px;
}

a {
  text-decoration: none;
}

button.btn-link {
  text-decoration: none;
  color: #4C4949;
}

button.btn-link:hover {
  color: #0056b3;
  text-decoration: none;
}

.spinner-border {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 0.15em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

</style>
